module.exports = __webpack_public_path__ + "static/media/fbclone.fa3c174f.png";